export default __webpack_public_path__ + "static/media/ourWig-laceTop.2c6fd08c.jpeg";